import { render, staticRenderFns } from "./SupportEmailLink.vue?vue&type=template&id=4a1f4280&"
import script from "./SupportEmailLink.vue?vue&type=script&lang=ts&"
export * from "./SupportEmailLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports